import {
	GamingHistoryRequestFilter,
	GamingHistoryResponse,
	TransactionDto,
} from "@api-types/games";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class GamingHistoryApiService {
	baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform`;
	}

	getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";

		return appHeaders;
	};

	async getGamingHistoryData(
		bodyData: GamingHistoryRequestFilter
	): Promise<GamingHistoryResponse> {
		const context = getApiRequestContext();
		return await httpClient.post(
			`${this.baseUrl()}/reports/GameHistory`,
			JSON.stringify(bodyData),
			this.getRequestHeaders(context)
		);
	}

	async getAvailableLiveGames(): Promise<Array<string>> {
		const context = getApiRequestContext();

		return await httpClient.get(
			`${this.baseUrl()}/casino-provider-games/live-game-groups`,
			this.getRequestHeaders(context)
		);
	}

	async getTransactionsPerRound(
		bodyData: GamingHistoryRequestFilter
	): Promise<{ result: TransactionDto[] }> {
		const context = getApiRequestContext();

		return await httpClient.post(
			`${this.baseUrl()}/reports/CasinoTransactions`,
			JSON.stringify(bodyData),
			this.getRequestHeaders(context)
		);
	}
}

const gamingHistoryApiService = new GamingHistoryApiService();

export { gamingHistoryApiService };
